module.exports = __webpack_public_path__ + "img/1.3dda260d.jpg";